import BaseService from "./BaseService";
import {ROOT, TRANSFER} from "./_base";

class TransferService extends BaseService {

    async initTransfer() {
        const response = await this.getByUri(`${ROOT}/${TRANSFER}/index`);
        return response.data
    }

    async getBalanceFromAccount(params) {
        const response = await this.getByUri(`${ROOT}/${TRANSFER}/get-account-info?${params}`);
        return response.data
    }

    async transfer(params) {
        const response = await this.post(`${ROOT}/${TRANSFER}/confirm-transfer`, params);
        return response.data
    }

    async confirm(params) {
        const response = await this.post(`${ROOT}/${TRANSFER}/transfer-money`, params);
        return response.data
    }

}

export default TransferService;
